export default __webpack_public_path__ + "static/media/logo_satelnet_small.2320e980.png";